
export enum FacilityStatusEnum {
    PROSPECT = 1,
    ACTIVE = 2,
    INACTIVE = 3
}

export const allFacilityStatuses = [
  FacilityStatusEnum.PROSPECT,
  FacilityStatusEnum.ACTIVE,
  FacilityStatusEnum.INACTIVE
]



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/facilityStatusEnum.ts